import { lazy as reactLazy } from "react";

const RELOAD_KEY = "chunk-reload-ts";

function isChunkError(err) {
  const msg = (err && (err.message || String(err))) || "";
  return /Loading chunk [\w-]+ failed/i.test(msg) || /ChunkLoadError/i.test(msg) || /Loading CSS chunk/i.test(msg) || /dynamically imported module/i.test(msg);
}

// Reload the page at most once per 10s (guarded against loops).
function reloadOnce() {
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last > 10000) {
      window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
      window.location.reload();
      return true;
    }
    return false;
  } catch (_) {
    window.location.reload();
    return true;
  }
}

// Reload only when the error looks like a stale/missing chunk (used by the
// global error/unhandledrejection listeners, where many unrelated errors flow).
export function reloadOnChunkError(err) {
  if (!isChunkError(err)) return false;
  return reloadOnce();
}

// Drop-in replacement for React.lazy. A failed route import is almost always a
// stale/missing chunk after a new deploy, so reload once to fetch the fresh
// build — regardless of how the browser words the error. If a reload already
// happened recently (truly offline / persistent failure), surface the error to
// the ErrorBoundary instead of looping.
export function lazyRetry(factory) {
  return reactLazy(() =>
    factory().catch((err) => {
      if (reloadOnce()) return new Promise(() => {}); // hold render during reload
      throw err;
    })
  );
}
